import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CalendarPrevious from './icon-calendar-previous.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CalendarPrevious {...validProps} />;
}
SvgComponent.iconName = 'calendarPrevious';

/**
 * @deprecated This is a legacy icon
 */
export const CalendarPreviousIcon = svgIconWrapper(SvgComponent);
